import dom from "../../../../common/ts/core/dom";
import location from "../../../../common/ts/core/location";
import {serviceContainer} from "../../serp/SerpServiceContainerFactory"
import {TrovitSerpData} from "../../serp/TrovitPageData";
import {connect} from "../../../../common/ts/connect";
import {ListingsSubscriber} from "../../serp/subscribers/ListingsSubscriber";
import {ToggleDescription} from "../../serp/subscribers/ToggleDescription";
import {ListingVisited} from "../../serp/subscribers/ListingVisited";
import {ConsentCookieIsAlreadySetEvent, PageLoadedEvent,} from "../../../../common/ts/events/Events";
import {EventBus} from "../../../../common/ts/events/EventBus";
import Sticky from "../../serp/components/Sticky";
import PointsOfCapture from "../../serp/components/retention/pointsOfCapture/PointsOfCapture";
import {GoogleOneTapSubscriber} from "../../serp/subscribers/GoogleOneTapSubscriber";
import webPushManager from "../../serp/components/retention/webPush/webPushManager";
import ConsentSubscriber from "../../serp/subscribers/ConsentSubscriber";
import {isConsentCookieSet, isDidomiConsentCookieSet} from "../../../../common/ts/components/core/ConsentCookie";
import PageGallery from "../../../../common/ts/components/PageGallery";
import {LocalStorageWrapper} from "../../../../common/ts/LocalStorageWrapper";
import tracking from "../../../../common/ts/core/tracking";
import http from "../../../../common/ts/core/http";
import FeaturesComponent from "../../detail/FeaturesComponent";
import LocationMap from "../../../../common/ts/components/LocationMap";
import MapData from "../../../../common/ts/types/MapData";
import AdLocationData from "../../../../common/ts/types/AdLocationData";
import AdCoordinates from "../../../../common/ts/AdCoordinates";
import ImageGallery from "../../../../common/ts/components/ImageGallery";
import PageData from "../../../../common/ts/PageData";
import {Brand} from "../../../../common/ts/types/Brand";
import {MiniSerp} from "../../miniSerp/MiniSerp";
import {MiniSerpUnits} from "../../miniSerp/MiniSerpUnits";

const eventBus: EventBus = EventBus.getInstance();
eventBus.subscribeWithId(
    PageLoadedEvent.TYPE,
    {
        id: 'trovit-project-page-loaded-subscriber',
        callback: (event) => {
            // TODO : create a specific ProjectPageData interface instead of using TrovitSerpData (risky)
            const trovitPageData: TrovitSerpData = (event as PageLoadedEvent<TrovitSerpData>).payload;
            connect(() => {
                dom.init();
                location.init();
                http.init();
                tracking.init();
                serviceContainer.get(ListingsSubscriber.name).init(trovitPageData);
                serviceContainer.get(ToggleDescription.name).init();
                serviceContainer.get(ListingVisited.name).init();
                serviceContainer.get(Sticky.name).init();
                serviceContainer.get(PointsOfCapture.name).init(trovitPageData);
                serviceContainer.get(GoogleOneTapSubscriber.name).init(trovitPageData);
                FeaturesComponent.init();
                locationMapInit();
                webPushManager.init(trovitPageData);
                serviceContainer.get(ConsentSubscriber.name).init(trovitPageData);
            });

            if (isDidomiConsentCookieSet() || isConsentCookieSet()) {
                eventBus.emit(new ConsentCookieIsAlreadySetEvent());
            }

            projectGalleryInit()
            miniSerpGalleriesInit()
            new LocalStorageWrapper().setItem("lastSerpUrl", decodeURIComponent(window.location.href));
            new MiniSerp().init();
            const pageData: PageData = (event as PageLoadedEvent<PageData>).payload;
            document
                .querySelectorAll<HTMLElement>(MiniSerpUnits.MINI_SERP_UNITS_CONTAINER_SELECTOR)
                .forEach(miniSerpUnitsContainer => {
                    new MiniSerpUnits({miniSerpUnitsContainer, pageData})
                        .init()
                });

            function miniSerpGalleriesInit() {
                new PageGallery(".js-mini-serp-container .swiper-container:has(.swiper-wrapper)");
            }

            function projectGalleryInit() {
                const imageGalleryData = {
                    device: trovitPageData.device,
                    floorPlans: trovitPageData.floorPlanUrls,
                    virtualTours: trovitPageData.virtualTourUrls,
                    brand: Brand.TROVIT,
                    id: trovitPageData.id,
                } as PageData
                // TODO : refactor : replace the PageData of the init function by a specific ImageGalleryData
                ImageGallery.init(imageGalleryData, '.project-page__gallery .js-image-gallery .gallery-swiper-container');
            }

            function locationMapInit() {
                // TODO : refactor: move those values to data attributes on the map container HTML and remove from PageData
                const mapContainer = document.querySelector('.js-project-page__map') as HTMLElement;
                if (mapContainer as HTMLElement) {
                    const mapData: MapData = {
                        showMap: mapContainer.dataset.showMap === 'true',
                        visibility: mapContainer.dataset.visibility ?? '',
                        accessToken: mapContainer.dataset.accessToken,
                        withControls: true,
                        zoom: mapContainer.dataset.zoom ? parseInt(mapContainer.dataset.zoom) : 10,
                        enableApproximateArea: mapContainer.dataset.enableApproximateArea === 'true',
                        adLocationData: {
                            coordinates: {
                                latitude: mapContainer.dataset.coordinatesLatitude,
                                longitude: mapContainer.dataset.coordinatesLongitude,
                            } as AdCoordinates,
                            address: mapContainer.dataset.address,
                            postcode: mapContainer.dataset.postcode,
                        } as AdLocationData
                    };
                    trovitPageData.country = mapContainer.dataset.country;
                    trovitPageData.pageViewType = mapContainer.dataset.pageViewType;
                    trovitPageData.id = mapContainer.dataset.id;
                    LocationMap.init(
                        {
                            mapData: mapData,
                            country: trovitPageData.country,
                            pageViewType: trovitPageData.pageViewType,
                            pageViewId: trovitPageData.pageViewId,
                            id: trovitPageData.id
                        }
                    );
                }
            }
        }
    }
)
